import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { logError } from '@office-start/telemetry-service';
import { httpPost } from '@office-start/xhr-service';
import { appendPvrAndUpnAuthParams } from './appendPvrAndUpnAuthParams';
export function createSway(swayOptions) {
    var url = "".concat(swayOptions.apiUrl, "/json/createStory");
    var requestConfig = {
        headers: {
            'X-UserSessionId': swayOptions.correlationId,
            'X-OHP-CorrelationId': swayOptions.correlationId,
        },
    };
    return httpPost(KnownInstrumentationEvents.SwayCreateRequest, "Sway_Create" /* KnownRequestInstrumentationEvents.SwayCreateRequest */, url, {}, requestConfig, swayOptions.jwtAuthEnabled, swayOptions.getAccessToken, swayOptions.officeHomeApiRoot, swayOptions.correlationId, 'Sway')
        .then(function (response) {
        if (response && response.data) {
            return appendPvrAndUpnAuthParams(response.data.url, swayOptions);
        }
        else {
            throw new Error((response === null || response === void 0 ? void 0 : response.statusText) ||
                'Could not parse Sway creation response');
        }
    })
        .catch(function (error) {
        logError({
            eventName: 'Sway_Create_Error',
            errorType: 'Sway_Create_Error',
            message: error,
        });
        throw error;
    });
}
//# sourceMappingURL=createSway.js.map